import _implicitStylesheets from "./picklist.css";

import _implicitScopedStylesheets from "./picklist.scoped.css?scoped=true";

import _lightningIcon from "lightning/icon";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, b: api_bind, h: api_element, c: api_custom_element, k: api_key, d: api_dynamic_text, t: api_text, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3, _m4} = $ctx;
  return [api_element("div", {
    classMap: {
      "slds-form-element": true,
      "picklist-pos__align": true
    },
    key: 0
  }, [api_element("div", {
    classMap: {
      "slds-form-element__control": true
    },
    key: 1
  }, [api_element("div", {
    classMap: {
      "slds-combobox_container": true
    },
    key: 2
  }, [api_element("div", {
    classMap: {
      "slds-combobox": true,
      "slds-dropdown-trigger": true,
      "slds-dropdown-trigger_click": true
    },
    attrs: {
      "aria-expanded": "false",
      "aria-haspopup": "listbox",
      "role": "combobox"
    },
    key: 3
  }, [api_element("div", {
    classMap: {
      "slds-combobox__form-element": true,
      "slds-input-has-icon": true,
      "slds-input-has-icon_right": true
    },
    attrs: {
      "role": "none"
    },
    key: 4
  }, [api_element("input", {
    classMap: {
      "slds-input": true,
      "slds-combobox__input": true
    },
    attrs: {
      "aria-controls": api_scoped_id("listbox-id-1"),
      "auto-complete": "off",
      "data-id": "combobox-id-1",
      "role": "textbox",
      "readonly": "",
      "type": "text",
      "data-my-id": "optionsInput"
    },
    props: {
      "value": $cmp.inputValue
    },
    key: 5,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleClick)),
      "blur": _m1 || ($ctx._m1 = api_bind($cmp.handleBlur))
    }
  }, []), api_element("div", {
    classMap: {
      "slds-input__icon-group": true,
      "slds-input__icon-group_right": true
    },
    key: 6
  }, [api_custom_element("lightning-icon", _lightningIcon, {
    classMap: {
      "slds-input__icon": true,
      "slds-input__icon_right": true
    },
    props: {
      "iconName": "utility:down",
      "size": "xx-small"
    },
    key: 7
  }, [])])]), api_element("div", {
    classMap: {
      "slds-dropdown": true,
      "slds-dropdown_length-5": true,
      "slds-dropdown_fluid": true
    },
    attrs: {
      "id": api_scoped_id("5"),
      "role": "listbox"
    },
    key: 8,
    on: {
      "mouseenter": _m2 || ($ctx._m2 = api_bind($cmp.handleMouseEnter)),
      "mouseleave": _m3 || ($ctx._m3 = api_bind($cmp.handleMouseleave))
    }
  }, [api_element("ul", {
    classMap: {
      "slds-listbox": true,
      "slds-listbox_vertical": true
    },
    attrs: {
      "role": "presentation"
    },
    key: 9
  }, api_iterator($cmp.inputOptions, function (option) {
    return api_element("li", {
      classMap: {
        "slds-listbox__item": true
      },
      attrs: {
        "data-selected": "false",
        "data-id": option.label,
        "data-value": option.label,
        "role": "presentation"
      },
      key: api_key(10, option.label),
      on: {
        "click": _m4 || ($ctx._m4 = api_bind($cmp.handleSelection))
      }
    }, [api_element("div", {
      classMap: {
        "slds-media": true,
        "slds-listbox__option": true,
        "slds-listbox__option_plain": true,
        "slds-media_small": true
      },
      attrs: {
        "role": "option",
        "data-my-id": option.value
      },
      key: 11
    }, [api_element("span", {
      classMap: {
        "slds-media__figure": true
      },
      key: 12
    }, [api_custom_element("lightning-icon", _lightningIcon, {
      classMap: {
        "slds-icon-utility-check": true,
        "slds-current-color": true,
        "slds-listbox__icon-selected": true,
        "slds-icon_container": true
      },
      props: {
        "iconName": "utility:check",
        "size": "x-small"
      },
      key: 13
    }, [])]), api_element("span", {
      classMap: {
        "slds-media__body": true
      },
      key: 14
    }, [api_element("span", {
      classMap: {
        "slds-truncate": true
      },
      attrs: {
        "title": option.label
      },
      key: 15
    }, [api_text(api_dynamic_text(option.label))])])])]);
  }))])])])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-picklist_picklist"
